export default "__VITE_ASSET__e909d125__"